<template>
    <form class="shaded mx-4 my-4" @submit.prevent.stop="next" novalidate>

        <div v-if="!getSelectedPerson" class="d-flex justify-content-end align-items-center my-1 py-2">
            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
            <input type="submit" class="btn blue wider" value="Next" :disabled="$v.form.$invalid">
        </div>

        <div class="form-group row mb-0">
            <div class="col-sm-7" v-if="showExistingAgentSelector">
                    <agent-existing-selector @valueChanged="useExistingOrCreateChanged"></agent-existing-selector>
            </div>
            <div class="col-sm-7" v-else-if="!this.getSelectedPerson">
                    <agent-virtual-or-invite v-model="form.saveAndSend" @valueChanged="createOffilneOrInviteAgent"></agent-virtual-or-invite>
            </div>
        </div>

        <div class="form-group row">
            <div :class="getSelectedPerson ? 'col-sm-12' : 'col-sm-7'">
                <div class="shaded" :class="getSelectedPerson ? '' : 'panel'">
                    <!-- <img src="/static/images/auth/agent.jpg" class="img-fluid mb-5"> -->

                    <div class="form-group row">
                        <div class="col-sm-12" v-if="getSelectedPerson">
                            <h5 class="d-flex justify-content-between align-items-center">
                                <span>PROFILE</span>
                                <div v-if="form.isLoading" class="d-flex justify-content-right align-items-center position-relative">
                                    <loader></loader>
                                </div>
                                <div v-else-if="!passedForm.isOTA" class="d-flex justify-content-right align-items-center position-relative">
                                    <button v-if="passedForm.inviteStatus == 5" class="btn blue mr-2" @click="callInviteAgent(passedForm)">Connect</button>
                                    <button v-if="passedForm.inviteStatus == 0" :disabled="emailChanged" class="btn blue mr-2" @click="callInviteAgent(passedForm)">Invite</button>
                                    <span v-else class="btn cursor-default radius-stadium" :class="peopleInviteStatus(passedForm).colorClass">{{peopleInviteStatus(passedForm).label}}</span>
                                    <!-- <button v-if="peopleInviteStatus(passedForm).actionLabel" class="btn green ml-2" @click="clickedActionButton(passedForm)" :class="peopleInviteStatus(passedForm).actionClass">{{peopleInviteStatus(passedForm).actionLabel}}</button> -->
                                    <!-- <i class="fas fa-ellipsis-h fs-largest ml-2 dark"></i>
                                    <ul class="connectActions position-absolute bg-lightest border-medium radius-normal">
                                        <li>Item 1</li>
                                        <li>Item 2</li>
                                        <li>Item 3</li>
                                    </ul> -->
                                    <three-dots v-if="listActions.length > 0" @input="selectedConnectionAction" :items="listActions"></three-dots>
                                </div>
                            </h5>

                        </div>

                        <div class="col-sm-6" :class="{ error: $v.form.brandName.$error }">

                            <div v-if="useExistingAgent" class="full">
                                <label class="m-0">Name <span class="color-6">*</span></label>
                                <v-select
                                :options="availableAgents"
                                label="brandName"
                                v-model="existingSelectedAgent"
                                placeholder="Select an agent"
                                @input="agentSelceted">
                             </v-select>
                            </div>

                            <label v-else class="full">
                                Name <span class="color-6">*</span>
                                <input type="text" :disabled="passedForm.isOTA" v-model="form.brandName" @input="$v.form.brandName.$touch">
                            </label>

                            <div v-if="$v.form.brandName.$error" class="messages">
                                <span v-if="!$v.form.brandName.required">Name is required.</span>
                                <span v-if="!$v.form.brandName.minLength">Name must have at least 3 characters.</span>
                            </div>
                        </div>


                        <div class="col-sm-2">
                            <label class="full">
                                Code
                                <input type="text" v-model="form.code">
                            </label>
                        </div>

                        <div v-if="getChannelSalesList && !passedForm.isOTA" class="col-sm-4">
                            <label>Business Type</label>

                            <v-select
                                v-model="selectedRole"
                                :options="getChannelSalesList"
                                placeholder="Pick a sales channel"
                                :searchable="true"
                                label="description"
                                @input="updateRole">
                            </v-select>
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-6" :class="{ error: $v.form.email.$error }">
                            <label class="full">
                                Email <span class="color-6">*</span>
                                <input type="text" v-model.trim="form.email" :disabled="disableEditEmail" @input="$v.form.email.$touch" @keyup="emailChanged = true">
                            </label>

                            <div v-if="$v.form.email.$error" class="messages">
                                <span v-if="!$v.form.email.email">Must be a valid email.</span>
                                <!-- <span v-if="!$v.form.email.isUnique">This email is already in use.</span> -->
                            </div>
                        </div>

                        <div class="col-sm-4 mb-4" :class="{ error: $v.form.phone.$error }">
                            <label class="full">
                                Phone
                                <input type="text" v-model="form.phone" @input="$v.form.phone.$touch">
                            </label>

                            <div v-if="$v.form.phone.$error" class="messages">
                                <span>This must be a phone number.</span>
                            </div>
                        </div>

                        <div class="col-sm-12" v-if="!passedForm.isOTA">
                            <label class="full">
                                Notes <span class="normal">(internal note)</span>
                                <textarea v-model="form.note"></textarea>
                            </label>
                        </div>

                    </div>

                    <div class="mb-5" v-if="!passedForm.isOTA">
                        <h5>CONTACTS</h5>

                        <div class="form-group row">
                            <div class="col-sm-6">
                                <label class="full">
                                    Financial Email
                                    <input type="text" v-model="form.contactFinancialEmail">
                                </label>
                            </div>

                            <div class="col-sm-4">
                                <label class="full">
                                    Financial Phone
                                    <input type="text" v-model="form.contactFinancialPhone">
                                </label>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-sm-6">
                                <label class="full">
                                    Sales Email
                                    <input type="text" v-model="form.contactSalesEmail">
                                </label>
                            </div>

                            <div class="col-sm-4">
                                <label class="full">
                                    Sales Phone
                                    <input type="text" v-model="form.contactSalesPhone">
                                </label>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-sm-6">
                                <label class="full">
                                    General Email
                                    <input type="text" v-model="form.contactOthersEmail">
                                </label>
                            </div>

                            <div class="col-sm-4">
                                <label class="full">
                                    General Phone
                                    <input type="text" v-model="form.contactOthersPhone">
                                </label>
                            </div>
                        </div>

                    </div>

                    <h5>BILLING DETAILS</h5>

                    <div class="form-group row">
                        <div class="col-sm-6">
                            <label class="full">
                                Billing name <span class="color-6">*</span>
                                <input type="text" v-model="form.name">
                            </label>
                        </div>

                        <div class="col-sm-4">
                            <label class="full">
                                VAT number
                                <input type="text" v-model="form.vat">
                            </label>
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-12">
                            <label class="full">
                                Address
                                <textarea v-model="form.address"></textarea>
                            </label>
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-4">
                            <label class="full">ZIP Code
                                <input type="text" v-model="form.zip">
                            </label>
                        </div>

                        <div class="col-sm-4">
                            <label class="full">Location
                                <input type="text" v-model="form.location">
                            </label>
                        </div>

                        <div class="col-sm-4 mb-4" v-if="form.country">
                            <label class="full">Country</label>
                                <v-select
                                v-model="form.country"
                                :options="getCountries"
                                :searchable="true"
                                label="name"
                                placeholder="- Select payment -">
                                </v-select>
                        </div>

                    </div>


                    <h5>Schedule Tasks</h5>

                    <div class="form-group row">
                        <div class="col-sm-6">
                            <checkbox v-model="form.isWorkflowAllowedToSendEmails">
                                Allow sending automatic emails
                            </checkbox>
                        </div>
                    </div>


                </div>
            </div>

            <!-- PAYMENT PROTOCOL - Hidden, now it show on the next tab (commissions tab) -->
            <div :class="getSelectedPerson ? 'col-sm-12' : 'col-sm-5'">

                <!-- <div class="shaded" :class="getSelectedPerson ? '' : 'panel'">
                    <div class="form-group row">
                        <div v-if="payments" class="col-sm-10">
                            <h5>PAYMENT PROTOCOL</h5>
                            <label class="full">Amount received by the agent</label>

                            <v-select
                                v-model="selectedPayment"
                                :options="payments"
                                :searchable="true"
                                label="description"
                                placeholder="- Select payment -"
                                @input="updatePayment">
                            </v-select>
                        </div>
                    </div>

                    <div v-if="payments && form.payment == 2" class="form-group row">
                            <div v-if="deposits" class="col-sm-8">
                                <label class="full">Deposit</label>

                                <v-select
                                    v-model="selectedDeposit"
                                    :options="deposits"
                                    :searchable="true"
                                    label="description"
                                    placeholder="- Select deposit -"
                                    @input="updateDeposit">
                                </v-select>

                                <div class="fs-smaller mt-2 dark">
                                    This is the deposit that the customer must pay at the time of booking.
                                </div>
                            </div>

                            <div v-if="showDepositValue" class="col-sm-3">
                                <label class="full">
                                    &nbsp;

                                    <div class="d-flex">
                                        <input class="glued-right" type="number" v-model="form.depositValue">
                                        <div class="glued-left">{{ selectedDeposit.symbol }}</div>
                                    </div>
                                </label>
                            </div>
                    </div>
                </div> -->

                <!-- Location -->
                <!-- <div class="shaded" :class="getSelectedPerson ? '' : 'panel'">
                    <h5>Location</h5>

                    <label class="full">
                        <input type="text" v-model="form.place" placeholder="e.g. Albufeira, Marina de Albufeira">
                        <div class="fs-smaller normal mt-2">Insert the location where this agent is selling</div>
                    </label>
                </div> -->

                <!-- <div class="shaded mt-3" :class="getSelectedPerson ? '' : 'panel'">
                    <h5>Advanced options</h5>

                    <div class="form-group">
                        <label class="d-flex">Allowed to book online
                            <toggle-button
                                class="ml-auto"
                                v-model="form.bookPermission"
                                :labels="{checked: 'YES', unchecked: 'NO'}"/>
                        </label>
                    </div>
                </div> -->
            </div>
        </div>

        <div v-if="!getSelectedPerson" class="d-flex justify-content-end align-items-center my-1 p-2">
            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
            <input type="submit" class="btn blue wider" value="Next" :disabled="$v.form.$invalid">
        </div>
    </form>
</template>

<script>
    import AgentExistingSelector from './AgentExistingSelector'
    import AgentVirtualOrInvite from './AgentNewSelector'
    import { mapActions, mapGetters } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import { required, email, minLength } from 'vuelidate/lib/validators'
    import threeDots from '@/tools/threeDots'
    import Loader from '@/tools/loaders/loader1'

    import { peopleMixin } from '@/mixins/people'

    export default {
        data: function() {
            return {
                useExistingAgent: false,
                selectedAgent: null,
                form: {
                    saveAndSend: true,
                    name: '',
                    brandName: '',
                    address: '',
                    contactFinancialEmail: '',
                    contactFinancialPhone: '',
                    contactSalesEmail: '',
                    contactSalesPhone: '',
                    contactOthersEmail: '',
                    contactOthersPhone: '',
                    note: '',
                    country: null,
                    vat: '',
                    zip: '',
                    place: '',
                    transportation: {},
                    contacts: [],
                    email: '',
                    phone: '',
                    role: null,
                    payment: 1,
                    deposit: null,
                    imageLogo: null,
                    imageLogoBase64: null,
                    locationMain: null,
                    agentSize: null,
                    salesChannel: null,
                    bookPermission: false,
                    DepositCurrency: "€",
                    SalesStore: false,
                    SalesWebsite: false,
                    SalesHotel: false,
                    currency: "€",
                    timezone: null, //qual é o formato?
                    slogan: "",
            		website: "",
            		facebook: "",
            		twitter: "",
            		pluraloUrl: "",
                },
                selectedRole: null,
                selectedPayment: null,
                selectedDeposit: null,
                originalSelectedAgent: {},
                existingSelectedAgent: null,
                emailChanged: false,
            }
        },
        props: {
            passedForm: {
                default: null
            },
            showExistingAgentSelector: {
                default: false
            }
        },
        validations: {
            form: {
                name: {
                    required,
                    minLength: minLength(3),
                },
                // code: {
                //     required,
                //     minLength: minLength(1),
                // },
                email: {
                    email,
                    required,
                    // isUnique () {
                    //     return (this.isUniqueEmail !== null)? this.isUniqueEmail : true;
                    // }
                },
                phone: {
                    // required,
                    minLength: minLength(4),
                },
                brandName: {
                    required,
                    minLength: minLength(2),
                },
            }
        },
        mixins:[
            peopleMixin
        ],
        created: function() {
            if(this.passedForm){
                this.form = this.passedForm;
            }else if (this.getSelectedPerson) {
                this.form = JSON.parse(JSON.stringify(this.getSelectedPerson));
            } else {
                for (let k in this.getNewAgentSetup) {
                    this.form[k] = this.getNewAgentSetup[k];
                }
            }

            //if no contry is slected it sets the default one
            if(!this.form.country){
                this.setDefaultCountry()
            }

            //set correct deposit
            this.setCorrectDeposit()

            // populate selection
            this.populateChannelSales()
        },
        computed: {
            ...mapGetters([
                'getSelectedPerson',
                'getNewAgentSetup',
                'getCountries',
                'account',
                'getAgents',
                'getChannelSalesList',
                'getDepositOptions',
                'getRequirePaymentOptions',
            ]),
            disableEditEmail: function () {
                if(this.form.inviteStatus <= 10){
                    return false
                }else {
                    return this.getSelectedPerson && this.form.isPhysicalAccountCreated || this.showExistingAgentSelector
                }
            },
            listActions: function () {
                let vm = this
                let action_disconnect = {
                    label: 'Disconnect',
                    toolTip: 'This agent will no longer <br >be able to book online, but <br> your team can book on his <br> behalf.',
                    action: function () {
                        vm.$dialog.confirm(
                            '<h1 class="text-center mb-4">Disconnect '+vm.passedForm.brandName+'?</h1><div class="fs-small"><p class="mb-2">They won\'t be able to see products, availabilities or book your products online but your teammates will continue to book on their behalf in the dashboard.</p><p>Pluralo will not let them know you disconnect them.</p></div>',
                            {
                                okText: 'Disconnect',
                                customClass: 'red'
                            }
                        ).then(function () {
                            vm.form.isLoading = true
                            vm.disconnectAgent({
                                agentId: vm.passedForm.id
                            }).then(response => {
                                vm.form.isLoading = false
                                vm.form.protocolStatus = 0
                                vm.form.inviteStatus = 5
                                vm.downloadAgents()
                                // vm.closeModal()
                            })
                        })
                        .catch(function () {
                        });

                    }
                }

                let action_connect = {
                    label: 'Connect',
                    toolTip: 'Invite this agent to connect with you',
                    action: function () {
                        vm.form.isLoading = true
                        vm.connectToAgent({
                            agent: vm.passedForm
                        }).then(response => {
                            vm.form.isLoading = false
                            vm.downloadAgents()
                            // vm.closeModal()
                        })
                    }
                }

                let action_invite = {
                    label: 'Invite',
                    toolTip: 'Invite this agent to join Pluralo',
                    action: function () {
                        vm.form.isLoading = true
                        vm.inviteAgent({
                            agent: vm.passedForm
                        }).then(response => {
                            vm.form.isLoading = false
                            vm.downloadAgents()
                            // vm.closeModal()
                        })
                    }
                }

                let action_blacklist = {
                    label: 'Send to blacklist',
                    toolTip: 'Both agent and your <br> teammates will be unable <br>to create bookings with <br> this agent as a seller',
                    action: function () {
                        vm.$dialog.confirm(
                            '<h1 class="text-center mb-4">Send '+vm.passedForm.brandName+' to Blacklist?</h1><div class="fs-small"><p class="mb-2">They won\'t be able to see or book your products and teammates will be unable to book on his behalf.</p><p>Pluralo will let them know you block them.</p></div>',
                            {
                                okText: 'Send to Blacklist',
                                customClass: 'red'
                            }
                        ).then(function () {
                            vm.form.isLoading = true
                            vm.suspendAgent({
                                agentId: vm.passedForm.id
                            }).then(response => {
                                vm.form.isLoading = false
                                vm.form.protocolStatus = 5
                                // vm.closeModal()
                                vm.downloadAgents()
                            })
                        })
                        .catch(function () {
                        });
                    }
                }

                let action_removeFromBlacklist = {
                    label: 'Remove from Blacklist',
                    toolTip: 'Enable both your team and agent to create bookings',
                    action: function () {
                        vm.$dialog.confirm(
                            '<h1 class="text-center mb-4">Unblock '+vm.passedForm.brandName+'?</h1><div class="fs-small"><p class="mb-2">They will be able to see or book your products and teammates will be able to book on his behalf.</p><p>Pluralo will let them know you unblocked them.</p></div>',
                            {
                                okText: 'Unblock',
                                // customClass: 'red'
                            }
                        ).then(function () {
                            vm.form.isLoading = true
                            vm.unsuspendAgent({
                                agentId: vm.passedForm.id
                            }).then(response => {
                                vm.form.isLoading = false
                                vm.form.protocolStatus = 1
                                vm.downloadAgents()
                                // vm.closeModal()
                            })
                        })
                        .catch(function () {
                        });
                    }
                }

                let actionsArray = []

                switch (this.passedForm.inviteStatus) {
                    // Connected
                    case 15:
                        if(this.passedForm.protocolStatus == 5){
                            actionsArray.push(action_removeFromBlacklist)
                        } else {
                            actionsArray.push(action_disconnect)
                            actionsArray.push(action_blacklist)
                        }
                        break;

                    // Pending
                    case 10:
                        if(this.passedForm.protocolStatus == 5){
                            actionsArray.push(action_removeFromBlacklist)
                        } else {
                            // actionsArray.push(action_connect)
                            actionsArray.push(action_blacklist)
                        }
                        break;

                    // Available
                    case 5:
                        if(this.passedForm.protocolStatus == 5){
                            actionsArray.push(action_removeFromBlacklist)
                        } else {
                            // actionsArray.push(action_connect)
                            actionsArray.push(action_blacklist)
                        }
                        break;
                    // Offline
                    case 0:
                        // actionsArray.push(action_invite)
                        if(this.passedForm.protocolStatus == 5){
                            actionsArray.push(action_removeFromBlacklist)
                        } else {
                            actionsArray.push(action_blacklist) //disabled for now
                        }
                        break;
                    default:

                }


                return actionsArray
            },
            availableAgents: function () {
                let output = this.getAgents.filter(agent => {
                    return agent.inviteStatus != 15
                })
                return output
            },
            agentInviteStatus: function() {
                // 1 = not registered on Pluralod
                // 2 = Pending connection
                // 3 = connected
                if(!this.form.isPhysicalAccountCreated){
                    //the agent has no account
                    return 1
                } else {
                    //the agent has an account
                    if(this.form.isPhysicalAccountConnected){
                        //the supplier and agent are connected
                        return 3
                    } else {
                        // agent not connected to supplier
                        return 2
                    }
                }
            },
            showDepositValue:function() {
                return this.selectedDeposit && this.selectedDeposit.id != 2
            },
            deposits: function () {
                return this.getDepositOptions
            },
            payments: function () {
                return this.getRequirePaymentOptions
            }
        },
        methods: {
            ...mapActions([
                'addAgentContact',
                'inviteAgent',
                'connectToAgent',
                'updateNewAgentSetup',
                'updateClonedAgent',
                'closeModal',
                'disconnectAgent',
                'suspendAgent',
                'unsuspendAgent',
                'downloadAgents'
            ]),
            selectedConnectionAction: function (item) {
                item.action()
            },
            setCorrectDeposit: function () {
                this.$set(this, 'selectedDeposit', this.getDepositOptions.find( depositOption => {
                        return depositOption.id == this.form.depositType
                    })
                )

                this.$set(this, 'selectedPayment', this.getRequirePaymentOptions.find(paymentOption => {
                        return paymentOption.id == this.form.payment
                    })
                )

            },
            clickedActionButton: function (passedForm) {

                switch (passedForm.inviteStatus) {
                    case 0:
                    case 1:
                    case 2:
                    case 5:
                    this.callInviteAgent(this.form)

                        break;
                    default:

                }
            },
            agentSelceted: function (selectedAgent) {
                    this.form = selectedAgent
                    this.form.email = this.getNewAgentSetup.email
            },
            useExistingOrCreateChanged: function (val) {
                this.useExistingAgent = val
                if(val == false){
                    this.clearAgent()
                } else {
                    // this.form = this.availableAgents[0]
                    this.form = {
                        name: null,
                        brandName: null,
                        address: '',
                        country: null,
                        vat: '',
                        zip: '',
                        place: '',
                        transportation: {},
                        contacts: [],
                        email: '',
                        phone: '',
                        role: null,
                        payment: 1,
                        deposit: null,
                        imageLogo: null,
                        imageLogoBase64: null,
                        locationMain: null,
                        agentSize: null,
                        salesChannel: null,
                        bookPermission: false,
                        DepositCurrency: "€",
                        SalesStore: false,
                        SalesWebsite: false,
                        SalesHotel: false,
                        currency: "€",
                        timezone: null, //qual é o formato?
                        slogan: "",
                		website: "",
                		facebook: "",
                		twitter: "",
                		pluraloUrl: "",
                    },
                    this.form.email = this.getNewAgentSetup.email
                }
            },
            createOffilneOrInviteAgent: function (val) {
                console.log('hey hey', val);
            },
            clearAgent: function () {
                this.form = this.getNewAgentSetup
            },
            callInviteAgent: function(agent) {
                if(agent.inviteStatus > 5){
                    this.$toasted.info('Already connected to this agent');
                    return true
                }

                if(agent.inviteStatus == 0){
                    this.inviteAgent({
                        supplierId: this.account.supplierId,
                        agent: agent
                    }).then(response => {
                        this.downloadAgents()
                        this.closeModal()
                    })
                } else if (agent.inviteStatus == 5) {
                    this.connectToAgent({
                        supplierId: this.account.supplierId,
                        agent: agent
                    }).then(response => {
                        this.downloadAgents()
                        this.closeModal()
                    })
                }
            },
            updateRole: function() {
                if(this.selectedRole){
                    this.form.role = this.selectedRole.id || null;
                }
            },
            addRow: function() {
                this.form.contacts.push(this.createEmptyRow());
            },
            populateChannelSales: function () {

                if (this.form.role) {
                    this.selectedRole = this.getChannelSalesList.find(item => item.id === this.form.role);
                }
                else {
                    this.selectedRole = this.getChannelSalesList[0];
                    this.form.role = this.getChannelSalesList[0].id;
                }
            },
            createEmptyRow: function() {
                return {
                    type: '',
                    email: '',
                    phone: '',
                    status: 'new',
                };
            },
            formatValue: function() {
                if (this.form.paymentValue !== undefined) {
                    this.form.depositValue = parseFloat(this.form.paymentValue).toFixed(2);
                }
            },
            updatePayment: function() {
                this.form.payment = this.selectedPayment.id;
                if (this.selectedPayment === this.payments[0]) {
                    this.form.paymentValue = 0;
                } else {
                    // if(this.deposits && this.deposits.length > 0){
                    //     this.selectedDeposit = this.deposits[0]
                    // }

                }
                this.formatValue();
            },
            updateDeposit: function() {
                // this.form.depositType = this.selectedDeposit.id;
                // this.form.deposit = this.selectedDeposit.id;

                this.$set(this.selectedDeposit, 'symbol', (this.selectedDeposit.id === 0) ? '€' : '%');
                this.$set(this.form, 'deposit', this.selectedDeposit.id)
                this.$set(this.form, 'depositType', this.selectedDeposit.id)
            },
            cancel: function() {
                this.$emit('cancelling');
            },
            save: function() {
                this.$emit('save');

            },
            next: function() {
                this.updateNewAgentSetup(this.form)
                this.$emit('goToNext', { invalid: this.$v.form.invalid, form: this.form });
            },
            setDefaultCountry: function() {
                let defaultCountry = this.getCountries.filter(country => {
                    return country.default
                })[0]

                this.form.country = defaultCountry
            }
        },
        components: {
            vSelect: extendedVSelect,
            AgentExistingSelector,
            AgentVirtualOrInvite,
            threeDots,
            Loader
        },
        watch: {
            $v: {
                handler: function (n, o) {
                    let toggleIsDisabled = n.form.$invalid ? true : false;

                    this.$emit('toggleIsDisabled', toggleIsDisabled);

                    // Can we save? Have all validations been passed?
                    // Then we'll send the 'actual' form so we can
                    // set it as selectedItem

                    if (!toggleIsDisabled) {
                        this.$emit('readyToSave', this.form);
                    }
                },
                deep: true
            },
            'getNewAgentSetup': {
                handler: function (n, o) {
                    this.populateChannelSales()
                },
                deep: true
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';

    .schedule {
        > li {
            display: flex;
            align-items: center;
            margin-bottom: 1rem;
            padding-top: 1rem;
            border-top: 1px solid $light;

            &:first-child {
                border: 0;
            }
        }
    }

    .add {
        margin-bottom: 3.5rem;
    }
</style>



// WEBPACK FOOTER //
// AgentForm.vue?1ba62c91